// extracted by mini-css-extract-plugin
export default {"shop":"Shop_shop__dXfLd"};